'use client';

import { useTranslations } from 'next-intl';

import { Button, ButtonAction } from '@/components/buttons/Button';
import { Link } from '@/i18n/navigation';
import { LocationDto } from '@/lib/locations/dto/location.dto';
import { getLocationPrimaryCtaType } from '@/models/location-utils';

type LocationCtasProps = {
  location: LocationDto;
  className?: string;
};

const STICKY_HEADER_HEIGHT = 150;

export default function LocationCtas({
  location,
  className,
}: LocationCtasProps) {
  const t = useTranslations('location');

  const locationType = getLocationPrimaryCtaType({
    phase: location.phase,
    isEarlyInPersonTourEnabled: location.isEarlyInPersonTourEnabled,
    calendlyLinks: location.calendlyLinks,
  });

  return (
    <div className={className}>
      <Button
        action={ButtonAction.SECONDARY}
        className="flex-1 max-sm:hidden"
        onClick={() => {
          const productSection = document.getElementById('products-section');
          if (productSection) {
            window.scrollTo({
              top:
                productSection.getBoundingClientRect().top -
                STICKY_HEADER_HEIGHT,
              behavior: 'smooth',
            });
          }
        }}
        data-testid="location-contact-cta"
      >
        {t('cta.see-available')}
      </Button>
      <Button
        as={Link}
        className="flex-1"
        href={`/location-form/${location.slug}`}
        data-testid="location-contact-cta"
      >
        {location.isWaitlisting
          ? t('cta.join-waitlist')
          : t(`cta.${locationType}`)}
      </Button>
    </div>
  );
}
